import CustomView from "../../custom-view";
import CustomView_Glist_Settings from "./settings";


export default class CustomView_GList extends CustomView<CustomView_Glist_Settings> {

    constructor(data:any) {
        super(data)

        this.settings = new CustomView_Glist_Settings(data.settings)
    }


}